import {Urls} from '../constants'
import 'styles/budgetCalculator.scss'

(function(){
	/* global $ */
	'use strict';

	var mountNode = document.getElementById("app");
        var loggedIn = false;

        $.fn.widthPerc = function () {
            var parent = this.parent();
            //  return ~~((this.width()/parent.width())*100)+"%";
            return ~~((this.width() / parent.width()) * 100);
        }


        function checkAuth() {

            if ($.sc.authSettings.login !== null) {
                loggedIn = true;
            }


            var fillFormComponentApi = new FillFormComponentApi({
                apiBaseUrl: "/s4s/api/",
                formId: Urls.form_budgetCalculator,
                mode: "",
                isTemp: false,
                finishAction: "",
                closeUrl: '/s4s/',
                tempFormId: '',
                isPrintView: false,
                isAuthenticated: loggedIn,
                signUpUrl: '/s4s/SignUp',
                isFillFormData: false
            });

            console.log('logged in is: ' + loggedIn);

            fillFormComponentApi.mount(mountNode);


            var checkExist = setInterval(function () {

                if ($('#app').is(':empty')) {

                    console.log('The container is empty.');
                } else {

                    console.log('The container contains something.');
                    clearInterval(checkExist);
                }

            }, 100);


            setTimeout(function () {

                $("#app .question-type-label strong:contains('Social Service Assessment')").parent().parent().html('<h2>Social Service Assessment</h2>');
                $(".col.span_12_of_12").parent().addClass("Outliner");
                $("#app .answer-btns.section.rhs").parent().parent().removeClass("Outliner");

                setTimeout(function () {

                    $('.question-type-text').addClass("textField");
                    $('label:contains("Sleep Rate (£)")').parent().addClass("textField");
                    $('#app .question-type-label').addClass("Q-label");
                    $('#app .question-type-calculation').addClass("calculate");
                    $('label:contains("Add another PA")').parent().addClass("PA-btn-demo");
                }, 200);

                // ....Then AUTO add numeric to each Question Chuck 
                setTimeout(function () {
                    $(".questions").each(function (i) {
                        $(this).addClass("Q" + (i + 1));
                    });
                    $(".calculate").each(function (i) {
                        $(this).addClass("T" + (i + 1));
                    });

                    $(".Q-label").each(function (i) {
                        $(this).addClass("Lab" + (i + 1));
                    });

                }, 200);

                // ---------------------------- Nav button renamed
                setTimeout(function () {
                    $('.blockBtns.small.alt.textAfterInput:contains("Finish")').addClass("finish-btn");
                }, 700);

                setTimeout(function () {
                    $('.blockBtns.small.alt.textAfterInput:contains("Finish")').html("Submit");
                }, 900);

                // $("<div class='Overall-Total'></div>").insertBefore('[id="561bf9fe-590d-4ba3-ba59-fad1d96d3877"]');
                checkboxesRadios();

            }, 800);

            // -------------------------------------------------------------------------------
            function checkboxesRadios() {

                setTimeout(function () {

                  

                    $('.question-type-text').addClass("textField");
                    $('label:contains("Sleep Rate (£)")').parent().addClass("textField");
                    $('#app .question-type-label').addClass("Q-label");
                    $('#app .question-type-calculation').addClass("calculate");
                    $('label:contains("Add another PA")').parent().addClass("PA-btn-demo");

                    setTimeout(function () {
                        $(".questions").each(function (i) {
                            $(this).addClass("Q" + (i + 1));
                        });
                        $(".calculate").each(function (i) {
                            $(this).addClass("T" + (i + 1));
                        });

                        $(".Q-label").each(function (i) {
                            $(this).addClass("Lab" + (i + 1));
                        });

                    }, 200);
                  

                    $('.PA-btn').remove();

                    // Map images for the radio button text
                    $('.question-type-singlecheckbox h2.fill-form-question-label').each(function () {

                        var thisText = $(this).text();

                        // star rating
                        if ($(this).text() === 'Add another PA') {
                            $(this).parent().append('<div class="PA-btn"><h2>Add another PA</h2></div>');
                        }

                        if ($(this).text() === 'Add another PA') {
                            $(this).parent().parent().parent().addClass('PA-Button');
                        }

                        // Create the text
                        //    $(this).parent().append('<p class="radio-text">' + thisText + '</p>');
                        //    $(this).text().css('text-indent', '-10000px');

                    });



                    $('.question-type-singlecheckbox input').each(function () {

                        if ($(this).is(':checked')) {
                            $(this).parent().parent().parent().find('.PA-btn').addClass('selected');

                        } else {

                            $(this).parent().parent().parent().find('.PA-btn').removeClass('selected');
                        }

                    });


                }, 200);



            }


            // Radio buttons
            $('body').on('change', '.question-type-singlecheckbox input', function () {

                checkboxesRadios();

            });

            $('body').on('click', '#app button.green.finish-btn', function () {
                // Buttons at the end of the form
                setTimeout(function () {
                    $('.cursor-pointer').each(function () {
                        //  console.log('$(this).text() is: ' + $(this).text());
                        if ($(this).text() === 'Print') {

                            console.log('END FORM PRINT');

                            //   $(this).text('Save as pdf');
                            $(this).parent().addClass('pcg-print-btn');
                            $(this).parent().after("<div class='pcg-helper-text'><p>To print or save your responses click on the button below. If you wish to save to your computer, select 'Save as PDF' and then save in a file on your device.</p></div>");
                            $(this).show();
                        }

                        $(this).show();
                    });
                }, 700);


            });


            $('body').on('click', '.PA-Button .question-type-singlecheckbox', function () {
                console.log('PA Button CLICKED');
                setTimeout(function () {

                    // PA 2
                    $('[id="717cd301-2f88-4cf5-a3bc-43bc1e0ccdb9"]').addClass("textField");
                    $('[id="d0cd6494-0149-4b75-85c9-7498fccdbecf"]').addClass("textField");
                    $('[id="58ac4f45-deb4-4ad6-913e-48e07dc0223a"]').addClass("calculate");


                    // PA 3
                    $('[id="97b4eb8f-c1aa-42a1-b8dd-4025f97ec9ad"]').addClass("textField");
                    $('[id="6e538d37-07b8-486d-bd4f-e8240d8a117b"]').addClass("textField");
                    $('[id="3e5cd41d-f307-4786-b2ce-de38cab3215e"]').addClass("calculate");


                    // PA 4
                    $('[id="7c7c7089-b013-4718-b25e-8ea421d53753"]').addClass("textField");
                    $('[id="548d08c9-2bc2-43f3-9498-8956cd5e9280"]').addClass("textField");
                    $('[id="049dab3f-3220-4842-850f-c30b846ab834"]').addClass("calculate");


                }, 200);


            });

            $('body').on('click', '.pcg-print-btn a', function (e) {
                e.preventDefault();
                window.print();
                e.stopPropagation();
            });

    }

    checkAuth();

})();